import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { usePurchaseOrderContractTaskPhases } from '@/hooks/api/0770_purchase_order_contract_task_phases';
import { useWorkspaceUsers } from '@/hooks/api/0150_workspace_users';
import { useBusinessPartners } from '@/hooks/api/0430_business_partners';
import { useBackofficeSearchCondition } from '@/providers/BackofficeSearchConditionProvider';
import { useMenuListedTeams } from '@/hooks/api/2260_menu_listed_teams';

export const SearchConditionTags = () => {
  const { _w_ } = useCurrentWorkspace();
  const { purchaseOrderContractTaskSearchCondition: searchCondition } = useBackofficeSearchCondition();
  const { data: phases } = usePurchaseOrderContractTaskPhases();
  const { data: users } = useWorkspaceUsers({ identifier: _w_!.identifier });
  const { data: businessPartners } = useBusinessPartners({ identifier: _w_!.identifier, page: 1, per: 1000 });
  const { data: teams } = useMenuListedTeams({ identifier: _w_!.identifier });
  const isConditionExist = Object.values(searchCondition)
    .flat()
    .some((v) => v);

  if (!isConditionExist) return <></>;

  return (
    <div className="d-flex mb-4 align-items-center flex-wrap">
      {searchCondition.subscribed && <span className="badge rounded-pill badge-info mx-1 my-1">マイリスト</span>}
      {phases &&
        phases
          .filter((d) => searchCondition.purchase_order_contract_task_phase_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.label}
            </span>
          ))}
      {users &&
        users
          .filter((d) => searchCondition.user_ids.includes(d.id))
          .map((d) => (
            <span key={`phase-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.user_account.name}
            </span>
          ))}
      {businessPartners &&
        businessPartners.business_partners
          .filter((d) => searchCondition.business_partner_ids.includes(d.id))
          .map((d) => (
            <span key={`bp-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.display_name}
            </span>
          ))}
      {teams &&
        teams.purchase_order_teams
          .filter((d) => searchCondition.team_ids.includes(d.id))
          .map((d) => (
            <span key={`pm-tag-${d.id}`} className="badge rounded-pill badge-info mx-1 my-1">
              {d.name}
            </span>
          ))}
      {searchCondition.archived ? (
        <span className="badge rounded-pill badge-primary mx-1 my-1">アーカイブ済タスクを含める</span>
      ) : (
        <span className="badge rounded-pill badge-secondary mx-1 my-1">アーカイブ済タスクを含めない</span>
      )}
    </div>
  );
};
